var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("dataScreening", {
            attrs: {
              propsData: {
                isCurrency: false,
                isPayChannel: false,
                adChannel: false,
                adPlacement: false,
                isCountry: false,
                isDate: false
              }
            },
            on: {
              searchChange: _vm.searchChange,
              currencyChange: _vm.currencyChange
            }
          }),
          _vm.rawData.game_mark.indexOf("yjfm") == -1
            ? [
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "flex-1",
                        attrs: { filterable: "", placeholder: "请选择" },
                        on: { change: _vm.getServer },
                        model: {
                          value: _vm.paramsData.is_prod,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "is_prod", $$v)
                          },
                          expression: "paramsData.is_prod"
                        }
                      },
                      _vm._l(_vm.severlist, function(item) {
                        return _c("el-option", {
                          key: item.label,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "flex-1",
                        attrs: {
                          clearable: "",
                          filterable: "",
                          placeholder: "请选择服务器"
                        },
                        on: { change: _vm.YjfmSeverChange },
                        model: {
                          value: _vm.paramsData.server_id,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "server_id", $$v)
                          },
                          expression: "paramsData.server_id"
                        }
                      },
                      _vm._l(_vm.serverList, function(item) {
                        return _c("el-option", {
                          key: item.serverID,
                          attrs: {
                            label: item.serverName,
                            value: item.serverID
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ]
            : [
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "flex-1",
                        attrs: { filterable: "", placeholder: "请选择" },
                        on: { change: _vm.envIdChange },
                        model: {
                          value: _vm.paramsData.env_id,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "env_id", $$v)
                          },
                          expression: "paramsData.env_id"
                        }
                      },
                      _vm._l(_vm.szgmEnv, function(item) {
                        return _c("el-option", {
                          key: item.label,
                          attrs: { label: item.label, value: item.id }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { filterable: "", placeholder: "服务器渠道" },
                        on: { change: _vm.serverChange },
                        model: {
                          value: _vm.server_channel,
                          callback: function($$v) {
                            _vm.server_channel = $$v
                          },
                          expression: "server_channel"
                        }
                      },
                      _vm._l(_vm.serverChannel, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          clearable: "",
                          filterable: "",
                          placeholder: "是否展示测试服"
                        },
                        on: { change: _vm.serverChannelChange },
                        model: {
                          value: _vm.show_test,
                          callback: function($$v) {
                            _vm.show_test = $$v
                          },
                          expression: "show_test"
                        }
                      },
                      _vm._l(_vm.serverType, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          filterable: "",
                          clearable: "",
                          placeholder: "服务器"
                        },
                        on: { change: _vm.severChange },
                        model: {
                          value: _vm.paramsData.server_id,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "server_id", $$v)
                          },
                          expression: "paramsData.server_id"
                        }
                      },
                      _vm._l(_vm.serverListYJ, function(item) {
                        return _c("el-option", {
                          key: item.serverID,
                          attrs: {
                            label: item.serverName,
                            value: item.serverID
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ],
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.searchClick(1)
                    }
                  }
                },
                [_vm._v("搜索")]
              )
            ],
            1
          )
        ],
        2
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  directives: [
                    {
                      name: "select-scroll",
                      rawName: "v-select-scroll",
                      value: _vm.loadMoreDocTypes,
                      expression: "loadMoreDocTypes"
                    }
                  ],
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: "文档类型"
                  },
                  model: {
                    value: _vm.paramsData.doc_type,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "doc_type", $$v)
                    },
                    expression: "paramsData.doc_type"
                  }
                },
                [
                  _vm._l(_vm.documentTypeList, function(item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value }
                    })
                  }),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "text-align": "center",
                        padding: "10px",
                        "font-size": "12px",
                        color: "#999"
                      }
                    },
                    [
                      _vm.docTypeLoading
                        ? _c("span", [
                            _c("i", { staticClass: "el-icon-loading" }),
                            _vm._v(" 加载中...")
                          ])
                        : !_vm.docTypeHasMore && _vm.documentTypeList.length > 0
                        ? _c("span", [_vm._v("没有更多文档类型了")])
                        : _vm._e()
                    ]
                  )
                ],
                2
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.addDocument()
                    }
                  }
                },
                [_vm._v("新增")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "sticky-table-header",
              rawName: "v-sticky-table-header",
              value: 0,
              expression: "0"
            },
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.reqLoading,
              expression: "reqLoading"
            }
          ],
          ref: "tableRef",
          staticStyle: { width: "100%" },
          attrs: { id: "tableRef", data: _vm.tableData, border: "" }
        },
        [
          _c("el-table-column", { attrs: { prop: "id", label: "ID" } }),
          _c("el-table-column", {
            attrs: { prop: "doc_type", label: "文档类型" }
          }),
          _c("el-table-column", { attrs: { prop: "version", label: "版本" } }),
          _c("el-table-column", {
            attrs: { prop: "server_id", label: "服务器ID" }
          }),
          _c("el-table-column", {
            attrs: { prop: "server_name", label: "服务器名称" }
          }),
          _c("el-table-column", {
            attrs: { prop: "source_type", label: "上传类型" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.source_type == "text"
                      ? _c("div", [_vm._v("文本")])
                      : _vm._e(),
                    scope.row.source_type == "upload"
                      ? _c("div", [_vm._v("文件")])
                      : _vm._e(),
                    scope.row.source_type == "external_url"
                      ? _c("div", [_vm._v("外部URL")])
                      : _vm._e(),
                    scope.row.source_type == "image"
                      ? _c("div", [_vm._v("图片")])
                      : _vm._e(),
                    scope.row.source_type == "video"
                      ? _c("div", [_vm._v("视频")])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "created_at", label: "创建时间" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", { staticClass: "exParam" }, [
                      _vm._v(_vm._s(_vm.$times.formDate(scope.row.created_at)))
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "status", label: "状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.status == "indexing"
                      ? _c("span", [_vm._v("进行中")])
                      : _vm._e(),
                    scope.row.status == "failed"
                      ? _c("span", [_vm._v("失败")])
                      : _vm._e(),
                    scope.row.status == "indexed"
                      ? _c("span", [_vm._v("成功")])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              fixed: "right",
              width: "150",
              align: "center"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", { staticClass: "x-c" }, [
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.$refs.writeDocumentDetail.open(
                                scope.row
                              )
                            }
                          }
                        },
                        [_vm._v("详情")]
                      )
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "custom-pagination" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", disabled: _vm.searchData.page === 1 },
              on: {
                click: function($event) {
                  return _vm.changePage(_vm.searchData.page - 1)
                }
              }
            },
            [_vm._v(" 上一页 ")]
          ),
          _c("span", { staticClass: "page-num" }, [
            _vm._v("第 " + _vm._s(_vm.searchData.page) + " 页")
          ]),
          _c(
            "el-button",
            {
              attrs: { size: "small", disabled: !_vm.hasMore },
              on: {
                click: function($event) {
                  return _vm.changePage(_vm.searchData.page + 1)
                }
              }
            },
            [_vm._v(" 下一页 ")]
          )
        ],
        1
      ),
      _c("writeDocumentDetail", { ref: "writeDocumentDetail" }),
      _c("addDocumetItem", {
        ref: "addDocumetItem",
        attrs: { prod: { env_id: _vm.paramsData.env_id } },
        on: {
          change: function($event) {
            return _vm.searchClick(1)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }